import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { CardRefresh } from '../../model/ngrx/card-refresh.model';

export const ADD_CARD_REFRESH = '[CARDREFRESH] Add';
export const REMOVE_CARD_REFRESH = '[CARDREFRESH] Remove';

// AddPersonalDetails
export class AddCardRefreshval implements Action {
    readonly type = ADD_CARD_REFRESH;

    constructor(public payload: CardRefresh) { }
}
// RemovePersonalDetails
export class RemoveCardRefreshval implements Action {
    readonly type = REMOVE_CARD_REFRESH;

    constructor(public payload: number) { }
}

export type Actions = AddCardRefreshval | RemoveCardRefreshval;
